import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/promo/actions/chatAction';
import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoIcon } from 'apps/promo/components/common/promo-icon/PromoIcon';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import ZendeskHelpSearch from 'apps/promo/components/help/ZendeskHelpSearch';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'apps/promo/components/utils';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';

import styles from './ZendeskHelp.module.css';

const ZendeskHelpPage = (props) => {
    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;
    const urlParams = useGetQueryParams();

    const filteredCategories = props.categories?.filter((category) => {
        return !category.directLink;
    });

    const categories = filteredCategories?.map((item) => {
        return (
            <PromoRow indent="adaptive-24-32" key={item.id} lastChildNoMargin>
                <a className={styles.helpLink} href={getHelpCenterUrl(`${url}/category/${item.id}`, urlParams)}>
                    <PromoText variant="h3">{item.name}</PromoText>
                    <PromoIcon name="chevron-right" size="24px" />
                </a>
            </PromoRow>
        );
    });

    const popularArticles = props.popular?.map((article) => {
        const section = props.sections?.find((s) => s.id === article.section_id);
        return (
            <PromoRow indent="adaptive-24-32" key={article.id}>
                <a
                    className={styles.helpLink}
                    href={getHelpCenterUrl(`${url}/category/${section?.category_id}/section/${article.section_id}/article/${article.id}`, urlParams)}
                >
                    <PromoText variant="h3">{article.title}</PromoText>
                    <PromoIcon name="chevron-right" size="16px" />
                </a>
            </PromoRow>
        );
    });

    const promotedArticles = props.promoted?.map((article) => {
        const section = props.sections?.find((s) => s.id === article.section_id);
        return (
            <PromoRow indent="adaptive-24-32" key={article.id} lastChildNoMargin>
                <a
                    className={styles.helpLink}
                    href={getHelpCenterUrl(`${url}/category/${section?.category_id}/section/${article.section_id}/article/${article.id}`, urlParams)}
                >
                    <PromoText>{article.title}</PromoText>
                    <PromoIcon name="chevron-right" size="16px" />
                </a>
            </PromoRow>
        );
    });

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                <HeadingSection title={props.pageHeadline} titleTag={'h1'} />
                {Array.isArray(popularArticles) && popularArticles.length > 0 && (
                    <div className={styles.popularArticles}>
                        <PromoRow indent="adaptive-32-48-64">
                            <PromoText tag={'h2'} variant={'h4'} textAlign={'center'}>
                                {props.popularArticlesTitle}
                            </PromoText>
                        </PromoRow>
                        {popularArticles}
                    </div>
                )}
                <PromoRow indent="adaptive-32-48-64">{categories}</PromoRow>
                {Array.isArray(promotedArticles) && promotedArticles.length > 0 && (
                    <div className={styles.promotedArticles}>
                        <PromoRow indent="adaptive-32-48-64">
                            <PromoText tag={'h2'} variant={'h4'} textAlign={'center'}>
                                {props.promotedArticlesTitle}
                            </PromoText>
                        </PromoRow>
                        {promotedArticles}
                    </div>
                )}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    pageHeadline: extra?.strapiApi?.page_headline?.title,
    promotedArticlesTitle: extra?.strapiApi?.promoted_articles_title,
    popularArticlesTitle: extra?.strapiApi?.popular_articles_title,
    categories: extra?.zendeskHelpData?.categories,
    sections: extra?.zendeskHelpData?.sections,
    promoted: extra?.zendeskHelpData?.promoted,
    popular: extra?.zendeskHelpData?.popular,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpPage));
